module.exports = __webpack_public_path__ + "img/ic_installation.89950288.svg";